import React, { useEffect, useState, useRef } from "react";
import {
  FaApple,
  FaTimes,
  FaUser,
  FaWindows,
  FaHeart,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import {
  FiFilter,
  FiGrid,
  FiPlay,
  FiSearch,
  FiStar,
  FiTrendingUp,
  FiAward,
  FiUsers,
  FiZap,
} from "react-icons/fi";
import { FiShoppingCart } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllActiveGames,
  getAllActiveGamesWithPagination,
} from "../Redux/Slice/game.slice";
import { getAllCategories, getAllCategoriesWithGameCount } from "../Redux/Slice/category.slice";
import { DiAndroid } from "react-icons/di";
import {
  addToCart as addToCartAction,
  fetchCart,
} from "../Redux/Slice/cart.slice";
import {
  addToWishlist,
  removeFromWishlist,
  fetchWishlist,
  checkWishlistStatus,
} from "../Redux/Slice/wishlist.slice";
import { useLocation, useNavigate } from "react-router-dom";
import gr from "../Asset/images/gr.svg";
// import gr2 from '../Asset/images/gr2.svg'
import gr3 from "../Asset/images/gr3.svg";
// import gr4 from '../Asset/images/gr4.svg'
import HyperButton from "../component/HyperButton";
import { motion } from "framer-motion";
import { BsGrid3X3Gap, BsListUl } from "react-icons/bs";
import BackgroundColor from "../component/BackgroundColor";
import ProductSkeleton from "../component/skeleton-loaders/ProductSkeleton";
import CategorySkeleton from "../component/skeleton-loaders/CategorySkeleton";

export default function Products() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("popular");
  const [grid, setGrid] = useState(3);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const sortDropdownRef = useRef(null);
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
  const [selectedPlatforms, setSelectedPlatforms] = useState({});
  const categoriesName = useSelector((state) => state.category.categoriesWithCount);
  const cartItems = useSelector((state) => state.cart?.items || []);
  const { items: wishlistItems, wishlistStatus } = useSelector(
    (state) => state.wishlist
  );
  const userId = localStorage.getItem("yoyouserId");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategoryQ, setSelectedCategoryQ] = useState("all");
  const gamesPerPage = 12;
  const [isPageChanging, setIsPageChanging] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [maxPageButtons, setMaxPageButtons] = useState(5); // Default to 5 buttons
  const searchInputRef = useRef(null);

  const {
    paginatedGames,
    totalGames,
    totalPages,
    loadingStates,
    error: gamesError,
  } = useSelector((state) => state.game);

  const { loadingStates: categoryLoadingStates, categories: categoryData } = useSelector((state) => state.category);

  useEffect(() => {
    document.title = "Games • YOYO";
    window.scrollTo(0, 0);
  }, [selectedCategory]);

  // Scroll to top when page changes
  // useEffect(() => {
  //   if (isPageChanging) {
  //     window.scrollTo({ top: 0, behavior: 'smooth' });
  //   }
  // }, [isPageChanging]);

  // Handle resize to adjust number of pagination buttons
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) { // md600 breakpoint
        setMaxPageButtons(3);
      } else if (window.innerWidth < 1024) { // lg breakpoint
        setMaxPageButtons(4);
      } else {
        setMaxPageButtons(6);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial value
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close sort dropdown on outside click or Escape
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && sortDropdownRef.current && !sortDropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  useEffect(() => {
    setIsInitialLoad(true);
    dispatch(getAllCategoriesWithGameCount());
    // Fetch cart items to check what's already added
    const userId = localStorage.getItem("yoyouserId");
    const token = localStorage.getItem("yoyoToken");
    if (userId && token) {
      dispatch(fetchCart());
      dispatch(fetchWishlist());
    }
  }, [dispatch]);

  useEffect(() => {
    // Debounce searchTerm
    const handler = setTimeout(() => {
      dispatch(
        getAllActiveGamesWithPagination({
          page: currentPage,
          limit: gamesPerPage,
          category: selectedCategoryQ._id,
          search: searchTerm?.trim(),
          isActive: true,
        })
      );
    }, 500); // 500ms debounce
    return () => {
      clearTimeout(handler);
    };
  }, [currentPage, selectedCategoryQ, searchTerm, dispatch]);

  // Reset page changing state when new data arrives
  useEffect(() => {
    if (paginatedGames && paginatedGames.length > 0) {
      setIsPageChanging(false);
    }
  }, [paginatedGames]);

  // Reset initial load state when categories are loaded
  useEffect(() => {
    if (categoriesName && categoriesName.length > 0) {
      setIsInitialLoad(false);
    }
  }, [categoriesName]);

  useEffect(() => {
    const st = location.state;
    if (!st || !Array.isArray(categoriesName)) {
      setSelectedCategoryQ("all"); // Default to "all" if no state or categories are available
      setSelectedCategory("all");
      return;
    }

    let foundCategory = null;

    if (st._id) {
      foundCategory = categoriesName.find((c) => c._id === st._id);
    } else if (st.id) {
      foundCategory = categoriesName.find(
        (c) => String(c.categoryName).toLowerCase() === String(st.id).toLowerCase()
      );
    } else if (st.name) {
      foundCategory = categoriesName.find(
        (c) => String(c.categoryName).toLowerCase() === String(st.name).toLowerCase()
      );
    }

    if (foundCategory) {
      setSelectedCategoryQ(foundCategory);
      setSelectedCategory(foundCategory.categoryName.toLowerCase());
    } else {
      setSelectedCategoryQ("all"); // Fallback to "all" if category not found
      setSelectedCategory("all");
    }

    setSearchTerm("");
    setCurrentPage(1);
  }, [location.state, categoriesName]);

  const options = [
    { value: "popular", label: "Most Popular" },
    { value: "price", label: "Price: Low to High" },
    { value: "price_desc", label: "Price: High to Low" },
    { value: "newest", label: "Newest First" },
  ];

  const handleSelect = (value) => {
    setSortBy(value);
    setIsOpen(false);
  };

  // Check if a game is already in cart for a specific platform
  const isGameInCart = (gameId, platform) => {
    return cartItems.some(
      (item) =>
        String(item.game?._id || item.game) === String(gameId) &&
        item.platform === platform
    );
  };

  // Icon mapping for categories
  const getIconForCategory = (categoryName) => {
    const iconMap = {
      action: FiZap,
      adventure: FiAward,
      puzzle: FiStar,
      racing: FiZap,
      sports: FiAward,
      strategy: FiStar,
      rpg: FiGrid,
      simulation: FiUsers,
      arcade: FiPlay,
      fighting: FiZap,
      platform: FiGrid,
      shooter: FiZap,
    };

    const key = categoryName?.toLowerCase();
    return iconMap[key] || FiGrid;
  };

  // Color mapping for categories
  const getColorForCategory = (categoryName) => {
    const colorMap = {
      action: "from-red-500 to-orange-500",
      adventure: "from-blue-500 to-indigo-500",
      puzzle: "from-purple-500 to-blue-500",
      racing: "from-yellow-500 to-orange-500",
      sports: "from-green-500 to-teal-500",
      strategy: "from-indigo-500 to-purple-500",
      rpg: "from-purple-500 to-pink-500",
      simulation: "from-cyan-500 to-blue-500",
      arcade: "from-pink-500 to-rose-500",
      fighting: "from-red-600 to-orange-600",
      platform: "from-green-400 to-blue-500",
      shooter: "from-gray-500 to-gray-700",
    };

    const key = categoryName.toLowerCase();
    return colorMap[key] || "from-purple-500 to-pink-500";
  };

  // Convert dynamic categories to the format expected by the component
  const getDynamicCategories = () => {
    const baseCategories = [
      {
        id: "all",
        name: "All Category",
        icon: FiGrid,
        count: categoriesName.reduce((acc, v) => acc + parseInt(v.gameCount), 0) || 0,
        color: "from-purple-500 to-pink-500",
      },
    ];

    const dynamicCategories =
      categoriesName?.map((category) => ({
        id: category?.categoryName.toLowerCase(),
        name: category?.categoryName,
        icon: getIconForCategory(category?.categoryName),
        count: category.gameCount,
        color: getColorForCategory(category?.categoryName),
        _id: category._id,
      })) || [];

    return [...baseCategories, ...dynamicCategories];
  };

  const getFormattedPaginatedGames = () => {
    return (
      paginatedGames?.map((game) => {
        const getAvailablePlatforms = () => {
          const platforms = game.platforms;
          if (!platforms) return {};
          const available = {};
          if (platforms.windows?.available)
            available.windows = platforms.windows;
          if (platforms.ios?.available) available.ios = platforms.ios;
          if (platforms.android?.available)
            available.android = platforms.android;
          return available;
        };

        const getBestPrice = () => {
          const platforms = game.platforms;
          if (!platforms) return "Free";
          const prices = [];
          Object.keys(platforms).forEach((p) => {
            if (platforms[p].available && platforms[p].price > 0)
              prices.push(platforms[p].price);
          });
          return prices.length === 0 ? "Free" : Math.min(...prices);
        };

        const isNew =
          new Date(game.createdAt) >
          new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

        return {
          id: game._id,
          title: game.title,
          category: game.category?.categoryName?.toLowerCase() || "action",
          tags: game.tags || [],
          price: getBestPrice(),
          cover_image: game.cover_image?.url,
          isNew,
          description: game.description,
          platforms: getAvailablePlatforms(),
        };
      }) || []
    );
  };

  const categories = getDynamicCategories();
  categories.sort((a, b) => b.count - a.count);

  // const games = getFormattedGames();
  const games = getFormattedPaginatedGames();

  const toggleFavorite = (gameId) => {
    if (!userId) {
      navigate("/login");
      return;
    }

    const isInWishlist = wishlistStatus[gameId];
    if (isInWishlist) {
      dispatch(removeFromWishlist({ gameId }));
    } else {
      dispatch(addToWishlist({ gameId }));
    }
  };

  const filteredGames = games.filter((game) => {
    const matchesCategory =
      selectedCategory === "all" ||
      game.category === selectedCategory ||
      // (selectedCategory === 'featured' && game.featured) ||
      (selectedCategory === "trending" && game.isNew);
    const matchesSearch =
      game.title?.trim().toLowerCase()?.includes(searchTerm?.trim().toLowerCase()) ||
      game.tags?.some((tag) =>
        tag?.trim().toLowerCase()?.includes(searchTerm?.trim().toLowerCase())
      );
    return matchesCategory && matchesSearch;
  });

  // Helper to get a game's price for sorting based on selected platform
  const getPriceForSorting = (game) => {
    const gamePlatforms = game.platforms || {};
    const selectedPlatformForGame =
      selectedPlatforms[game.id] || (gamePlatforms.windows ? "windows" : null);

    if (selectedPlatformForGame && gamePlatforms[selectedPlatformForGame]) {
      const price = gamePlatforms[selectedPlatformForGame].price;
      return typeof price === "number" ? price : 0;
    }

    const prices = Object.values(gamePlatforms)
      .map((p) => (typeof p?.price === "number" ? p.price : 0))
      .filter((n) => n > 0);
    return prices.length ? Math.min(...prices) : 0;
  };

  const sortedGames = [...filteredGames].sort((a, b) => {
    switch (sortBy) {
      case "popular":
        // Assuming "popular" implies maintaining the order provided by the backend
        // or no specific client-side sort if no popularity metric is available.
        // If a specific popularity metric (e.g., 'salesCount', 'views') exists on game objects,
        // it should be used here (e.g., `b.salesCount - a.salesCount`).
        return 0;
      case "price":
        return getPriceForSorting(a) - getPriceForSorting(b);
      case "price_desc":
        return getPriceForSorting(b) - getPriceForSorting(a);
      case "newest":
        // Sorts games with `isNew: true` before games with `isNew: false`.
        // If a `createdAt` timestamp was available, `new Date(b.createdAt) - new Date(a.createdAt)`
        // would provide a more precise "newest" sort.
        return (b.isNew ? 1 : 0) - (a.isNew ? 1 : 0);
      default:
        return 0;
    }
  });

  useEffect(() => {
    if (isSearchOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isSearchOpen]);

  return (
    <BackgroundColor className="relative mx-auto w-[95%] sm:w-[92%] md:w-[90%] lg:max-w-[80%]">
      {/* Hero Section */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="relative overflow-hidden"
      >
        {/* <div className="absolute inset-0 bg-gradient-to-r from-purple-800/50 to-pink-800/50"></div> */}
        <div className="relative pt-20 pb-6 lg:py-16">
          <h1 className="text-[25px] lg:text-[60px] font-bold mb-3 text-center">
            <span className="gradient-text">Game </span>Universe
          </h1>
          <p className="text-sm lg:text-base text-primary-light/60 max-w-7xl mx-auto text-center mb-5 line-clamp-3 md:line-clamp-none">
            Welcome to Game center, You will be able to find all the games at one place. You can explore a very large and diverse collection or range of types or categories such as racing, sports, action, adventure, puzzles, and more. We have something for everyone, whether you prefer thrilling missions, a style of fighting, often in video games or sports, undisturbed games. Survey our whole collection, find new books and games, and have a relaxation and enjoyment at your fingertips.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-300">
            <HyperButton label="Explore" icon={FiZap} size="sm" />
            <HyperButton label="Buy" icon={FiShoppingCart} size="sm" />
            <HyperButton label="Enjoy" icon={FiPlay} size="sm" />
          </div>
        </div>
      </motion.div>

      <div className="relative pb-8">
        <div className="grid grid-cols-4 gap-4 lg:gap-8">
          {/* Categories Sidebar */}
          <motion.div
            initial={{ opacity: 0, x: -16 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="col-span-1 hidden md:block"
          >
            {(() => {
              const isLoading = categoryLoadingStates?.getAllCategories === true;
              const hasNoData = !categoriesName || categoriesName.length === 0;
              const shouldShowSkeleton = isLoading || isPageChanging || hasNoData || isInitialLoad;
              return shouldShowSkeleton;
            })() ? (
              <CategorySkeleton />
            ) : (
              <div className="bg-white/5 backdrop-blur-xl rounded-xl xl:rounded-3xl p-3 xl:p-6 border border-white/10 sticky top-24 max-h-[calc(100vh-7rem)] overflow-y-auto no-scrollbar">
                <h3 className="text-base lg:text-lg xl:text-2xl font-bold text-white mb-3 xl:mb-6 flex items-center gap-3">
                  <FiGrid className="hidden lg:block w-6 h-6 text-purple-400" />
                  Categories
                </h3>
                <div className="space-y-3">
                  {categories.map((category) => {
                    const IconComponent = category.icon;
                    return (
                      <button
                        key={category.id}
                        onClick={() => {
                          setSelectedCategory(category.id);
                          setSelectedCategoryQ(category);
                        }}
                        className={`w-full group relative overflow-hidden rounded-md xl:rounded-2xl transition-all duration-300 hover:scale-105 ${selectedCategory === category.id
                          ? "bg-gradient-to-r " +
                          category.color +
                          " text-white shadow-2xl"
                          : "bg-white/5 text-white/80 hover:bg-white/10 border border-white/10"
                          }`}
                      >
                        <div className="flex items-center justify-between p-2 xl:p-4">
                          <div className="flex items-center gap-3 text-sm">
                            {/* <IconComponent className="w-5 h-5 hidden lg:block" /> */}
                            <span className="font-medium">{category.name}</span>
                          </div>
                          <span
                            className={`hidden lg:block text-xs px-2 py-1 rounded-full ${selectedCategory === category.id
                              ? "bg-white/20"
                              : "bg-white/10"
                              }`}
                          >
                            {category.count}
                          </span>
                        </div>
                        {selectedCategory === category.id && (
                          <div className="absolute inset-0 bg-white/10 animate-pulse"></div>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
          </motion.div>

          {/* Games Grid */}

          <div className="md:col-span-3 col-span-4">
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {/* Search and Filters */}
              <div className="bg-white/5 backdrop-blur-xl rounded-lg lg:rounded-2xl p-3 md:p-4 mb-4 border border-white/10 relative z-20">
                <div className="flex md:justify-end flex-col md600:flex-row gap-3">
                  {/* Search */}
                  <div className="flex justify-start md:justify-end gap-1">
                    {isSearchOpen && (
                      <div className="relative flex-1">
                        <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white/60 w-5 h-5" />
                        <input
                          type="text"
                          placeholder="Search for your next adventure..."
                          value={searchTerm}
                          ref={searchInputRef}
                          onChange={(e) => { setCurrentPage(1); setSearchTerm(e.target.value); }}
                          className="w-full pl-12 pr-6 py-2 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent transition-all backdrop-blur text-sm"
                        />
                      </div>
                    )}
                    <button
                      onClick={() => {
                        setIsSearchOpen(!isSearchOpen);
                        setSearchTerm("");
                      }}
                      className="inline-flex md:hidden items-center justify-end text-xl rounded-full text-white/60 hover:text-white focus:outline-none transition-all duration-300 outline-none"
                    >
                      {isSearchOpen ? <FaTimes /> : <FiSearch />}
                    </button>
                  </div>

                  {/* Sort and View Controls */}
                  <div className="flex justify-start sm:justify-between flex-col sm:flex-row sm:items-center gap-2">
                    <button
                      onClick={() => {
                        setIsSearchOpen(!isSearchOpen);
                        setSearchTerm("");
                      }}
                      className="hidden md:inline-flex items-center justify-end text-xl rounded-full text-white/60 hover:text-white focus:outline-none transition-all duration-300 outline-none"
                    >
                      {isSearchOpen ? <FaTimes /> : <FiSearch />}
                    </button>

                    <div className="md:flex hidden gap-2 items-center">
                      <div className="flex items-center gap-2">
                        <button
                          className={`p-2 rounded-lg font-semibold transition text-xl flex items-center justify-center ${grid === 3
                            ? "bg-purple-600 text-white shadow"
                            : "bg-white/10 text-gray-300 hover:bg-purple-600 hover:text-white"
                            }`}
                          onClick={() => setGrid(3)}
                          aria-label="Card View"
                        >
                          <BsGrid3X3Gap />
                        </button>
                        <button
                          className={`p-2 rounded-lg font-semibold transition text-xl flex items-center justify-center ${grid === 1
                            ? "bg-purple-600 text-white shadow"
                            : "bg-white/10 text-gray-300 hover:bg-purple-600 hover:text-white"
                            }`}
                          onClick={() => setGrid(1)}
                          aria-label="List View"
                        >
                          <BsListUl />
                        </button>
                      </div>
                    </div>

                    <div className="flex gap-2">
                      <div className="flex items-center gap-2">
                        {/* <FiGamepad className="block sm:hidden text-white/60 w-5 h-5" /> */}
                        <div className="relative inline-block text-left md:hidden">
                          {/* Dropdown Button */}
                          <button
                            onClick={() => {
                              setIsCategoriesOpen(!isCategoriesOpen);
                              setIsOpen(false);
                            }}
                            className="bg-white/10 border border-white/20 rounded-md md:rounded-lg px-3 md:px-6 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-400 backdrop-blur flex justify-between items-center w-full sm375:w-44 md:w-64 lg:w-72 text-sm"
                          >
                            {/* Categories */}
                            {
                              categories.find((c) => c?.id === selectedCategory)
                                ?.name
                            }
                            <svg
                              className={`w-4 h-4 ml-2 transition-transform ${isCategoriesOpen ? "rotate-180" : ""
                                }`}
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </button>

                          {/* Dropdown Menu */}
                          {isCategoriesOpen && (
                            <div className="text-sm max-h-[300px] overflow-auto absolute mt-2 w-full sm375:w-44 md:w-64 lg:w-72 bg-black/80 backdrop-blur border border-white/10 rounded-md md:rounded-lg text-white z-50">
                              {categories.map((category) => {
                                return (
                                  <button
                                    key={category.id}
                                    onClick={() => {
                                      setSelectedCategory(category.id);
                                      setSelectedCategoryQ(category)
                                      setIsCategoriesOpen(false);
                                    }}
                                    className={`w-full group relative overflow-hidden transition-all duration-300 ${selectedCategory === category.id
                                      ? "bg-gradient-to-r " +
                                      category.color +
                                      " text-white shadow-2xl"
                                      : "bg-white/5 text-white/80 hover:bg-white/10"
                                      }`}
                                  >
                                    <div className="flex items-center justify-start p-2">
                                      <span className="font-medium">
                                        {category.name}
                                      </span>
                                    </div>
                                    {selectedCategory === category.id && (
                                      <div className="absolute inset-0 bg-white/10 animate-pulse"></div>
                                    )}
                                  </button>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        {/* <FiFilter className="text-white/60 w-5 h-5" /> */}
                        <div className="relative inline-block text-left" ref={sortDropdownRef}>
                          {/* Dropdown Button */}
                          <button
                            onClick={() => {
                              setIsOpen(!isOpen);
                              setIsCategoriesOpen(false);
                            }}
                            className="bg-white/10 border border-white/20 rounded-md md:rounded-lg px-3 md:px-6 py-2 text-white focus:outline-none focus:ring-2 focus:ring-purple-400 backdrop-blur flex justify-between items-center w-full sm375:w-36 md:w-48 lg:w-64 text-sm hover:bg-white/15 transition"
                          >
                            {options.find((o) => o.value === sortBy)?.label}
                            <svg
                              className={`w-4 h-4 ml-2 transition-transform ${isOpen ? "rotate-180" : ""
                                }`}
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </button>

                          {/* Dropdown Menu */}
                          {isOpen && (
                            <div className="text-sm absolute mt-2 w-full sm375:w-36 md:w-48 lg:w-64 bg-black/80 backdrop-blur border border-white/10 rounded-md md:rounded-lg  shadow-2xl shadow-purple-900/20 text-white z-50 overflow-hidden">
                              {options.map((option) => (
                                <div
                                  key={option.value}
                                  onClick={() => handleSelect(option.value)}
                                  className={`px-3 md:px-6 py-2 transition-colors ${sortBy === option.value
                                    ? "bg-purple-500/30 text-white"
                                    : "hover:bg-white/10 text-white/90"
                                    }`}
                                >
                                  {option.label}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between mb-4 xl:mb-8">
                <div>
                  {loadingStates.getAllActiveGamesWithPagination ? (
                    <>
                      <div className="h-8 bg-gray-600/50 rounded animate-pulse w-48 mb-2"></div>
                      <div className="h-4 bg-gray-600/50 rounded animate-pulse w-64"></div>
                    </>
                  ) : (
                    <>
                      <h2 className="text-xl xl:text-3xl font-bold text-white mb-1 xl:mb-2 tracking-wider">
                        {selectedCategory === "all"
                          ? "All Games"
                          : categories.find((c) => c.id === selectedCategory)
                            ?.name || "Games"}
                      </h2>
                      <p className="text-white/60 text-sm xl:text-base">
                        {selectedCategory === "all"
                          ? `Showing ${sortedGames?.length} of ${categories[0]?.count} games`
                          : `Showing ${sortedGames?.length} of ${selectedCategoryQ.count || selectedCategoryQ?.gameCount} games`
                        }
                      </p>
                    </>
                  )}
                </div>
              </div>
            </motion.div>

            <motion.section
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {loadingStates.getAllActiveGamesWithPagination || isPageChanging || !sortedGames ? (
                <ProductSkeleton grid={grid} />
              ) : (
                <>
                  <div
                    className={`grid ${grid === 1
                      ? "grid-cols-1"
                      : "grid-cols-1 md600:grid-cols-2 3xl:grid-cols-3"
                      } gap-4 xl:gap-8 relative z-10`}
                  >
                    {sortedGames?.map((game, index) => {
                      const selectedPlatform =
                        selectedPlatforms[game.id] ||
                        (game.platforms?.windows
                          ? "windows"
                          : game.platforms?.ios
                            ? "ios"
                            : game.platforms?.android
                              ? "android"
                              : "windows");
                      return (
                        <div
                          key={game.id}
                          className={`group relative bg-white/5 backdrop-blur-xl rounded-xl lg:rounded-3xl overflow-hidden border border-white/10 hover:border-purple-400/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/20  ${grid === 1 ? "md:flex" : ""
                            }`}
                          style={{ animationDelay: `${index * 0.1}s` }}
                          onClick={() => {
                            navigate(`/gamedetails/${game.id}`);
                          }}
                        >
                          {/* Image Container */}
                          <div
                            className={`relative overflow-hidden ${grid === 1
                              ? "w-full md:w-60 lg:w-64 md:h-full"
                              : "h-48"
                              }`}
                          >
                            <img
                              src={game?.cover_image}
                              alt={game?.title}
                              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                            {/* Badges */}
                            <div className="absolute top-4 left-4 flex gap-2">
                              {game.isNew && (
                                <span className="bg-gradient-to-r from-green-500 to-emerald-500 text-white px-3 py-1 rounded-full text-xs font-bold animate-pulse">
                                  NEW
                                </span>
                              )}
                            </div>

                            {/* Action Buttons */}
                            <div className="absolute top-4 right-4 flex gap-2 opacity-100 transition-opacity duration-300 z-10">
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  toggleFavorite(game.id);
                                }}
                                className={`p-2 rounded-full backdrop-blur-md transition-all duration-300 ${wishlistStatus[game.id]
                                  ? "bg-red-500 text-white scale-110"
                                  : "bg-black/30 text-white hover:bg-red-500 hover:scale-110"
                                  }`}
                              >
                                <FaHeart
                                  className={`w-4 h-4 ${wishlistStatus[game.id] ? "fill-current" : ""
                                    }`}
                                />
                              </button>
                            </div>

                            {/* Play Button Overlay */}
                            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 z-5">
                              <button className="bg-white/90 text-gray-900 p-4 rounded-full hover:bg-white hover:scale-110 transition-all duration-300 shadow-2xl">
                                <FiPlay className="w-6 h-6 ml-1" />
                              </button>
                            </div>
                          </div>

                          {/* Content */}
                          <div
                            className={`p-3 xl:p-6 ${grid === 1 ? "md:flex-1" : ""
                              }`}
                          >
                            <h3 className="text-base lg:text-xl font-bold text-white mb-2 group-hover:text-purple-300 transition-colors">
                              {game.title.replace(/"/g, "")}
                            </h3>

                            <p className="text-gray-400 text-xs lg:text-sm mb-4 line-clamp-3">
                              {game.description.replace(/"/g, "")}
                            </p>
                            {/* Platforms */}
                            <div className="mt-4">
                              <h4 className="text-lg font-semibold text-white tracking-wider">
                                Platforms :
                              </h4>
                              <div className="text-white/40 text-base flex gap-4 mt-2">
                                {Object.keys(game.platforms).map((platform) => (
                                  <div
                                    key={platform}
                                    className={`flex items-center`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setSelectedPlatforms((prev) => ({
                                        ...prev,
                                        [game.id]: platform,
                                      }));
                                    }}
                                  >
                                    {platform === "windows" && (
                                      <FaWindows
                                        title="Show Windows Price"
                                        className={`${selectedPlatform === platform
                                          ? "text-blue-500"
                                          : ""
                                          }`}
                                      />
                                    )}
                                    {platform === "ios" && (
                                      <FaApple
                                        title="Show Ios Price"
                                        className={`${selectedPlatform === platform
                                          ? "text-white"
                                          : ""
                                          }`}
                                      />
                                    )}
                                    {platform === "android" && (
                                      <DiAndroid
                                        title="Show Android Price"
                                        className={`${selectedPlatform === platform
                                          ? "text-green-500"
                                          : ""
                                          }`}
                                      />
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                            {/* Tags */}
                            {/* <div className="flex flex-wrap gap-2 mb-4">
                                                {game.tags.slice(0, 3).map(tag => (
                                                    <span
                                                        key={tag}
                                                        className="px-3 py-1 bg-gradient-to-r from-purple-500/20 to-pink-500/20 text-purple-200 text-xs rounded-full border border-purple-400/30"
                                                    >
                                                        {tag}
                                                    </span>
                                                ))}
                                            </div> */}

                            {/* Price and CTA */}
                            <div className="flex items-center md:items-start lg:items-center justify-between flex-row md:flex-col lg:flex-row">
                              <div className="mt-2 text-white flex flex-col gap-1 text-sm lg:text-base">
                                <p className="">
                                  Price - ${" "}
                                  {game.platforms[selectedPlatform]?.price}
                                </p>
                                <p className="">
                                  Size - {game.platforms[selectedPlatform]?.size}
                                </p>
                              </div>

                              {isGameInCart(game.id, selectedPlatform) ? (
                                <button
                                  disabled
                                  className="bg-gray-500 text-white px-1 py-2 lg:px-3 lg:py-2 text-sm rounded-md font-medium flex items-center gap-2 cursor-not-allowed mt-0 md:mt-2 lg:mt-0"
                                >
                                  <FiShoppingCart className="w-4 h-4" />
                                  Already Added
                                </button>
                              ) : !userId ? (
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    navigate("/login");
                                  }}
                                  className="bg-gradient-primary text-white p-2 lg:px-3 lg:py-2 text-sm rounded-md font-medium transition-all hover:scale-105 flex items-center gap-2 mt-0 md:mt-2 lg:mt-0"
                                >
                                  <FaUser className="w-4 h-4" />
                                  Login to Add
                                </button>
                              ) : (
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    dispatch(
                                      addToCartAction({
                                        gameId: game.id,
                                        platform: selectedPlatform,
                                        qty: 1,
                                      })
                                    );
                                  }}
                                  className="bg-gradient-primary text-white p-2 lg:px-3 lg:py-2 text-sm rounded-md font-medium transition-all hover:scale-105 flex items-center gap-2 mt-0 md:mt-2 lg:mt-0"
                                >
                                  <FiShoppingCart className="w-4 h-4" />
                                  Add To Cart
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {sortedGames.length === 0 && !loadingStates.getAllActiveGamesWithPagination && !isPageChanging && (
                    <div className="text-center py-20">
                      <FiGrid className="w-16 h-16 text-white/30 mx-auto mb-4" />
                      <div className="text-white/60 text-2xl mb-4">
                        No games found
                      </div>
                      <div className="text-white/40">
                        Try adjusting your search or category filters
                      </div>
                    </div>
                  )}
                </>
              )}
            </motion.section>
          </div>
          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-center md600:justify-end items-center mt-8 space-x-2 col-span-4">
              <button
                onClick={() => {
                  setIsPageChanging(true);
                  setCurrentPage((prev) => Math.max(1, prev - 1));
                }}
                disabled={currentPage === 1}
                className="p-1 md:p-2 rounded-md text-white hover:bg-gray-700/40 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
              >
                <FaChevronLeft />
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (page) => {
                  // Calculate start and end page for the visible range
                  const startPage = Math.max(
                    1,
                    currentPage - Math.floor(maxPageButtons / 2)
                  );
                  const endPage = Math.min(
                    totalPages,
                    startPage + maxPageButtons - 1
                  );

                  if (
                    page === 1 ||
                    page === totalPages ||
                    (page >= startPage && page <= endPage)
                  ) {
                    return (
                      <button
                        key={page}
                        onClick={() => {
                          setIsPageChanging(true);
                          setCurrentPage(page);
                        }}
                        className={`px-2 py-1 md:px-4 md:py-2 rounded-md text-sm sm:text-base font-medium transition-all duration-300 ring-[1px] ring-primary-light/10
                                            ${currentPage === page
                            ? "bg-gradient-primary text-white"
                            : " text-white hover:bg-gray-700/40"
                          }`}
                      >
                        {page}
                      </button>
                    );
                  }
                  // Show ellipsis for pages outside the visible range but not the first/last
                  if (
                    (page === startPage - 1 && startPage > 2) ||
                    (page === endPage + 1 && endPage < totalPages - 1)
                  ) {
                    return (
                      <span key={page} className="text-white">
                        ...
                      </span>
                    );
                  }
                  return null;
                }
              )}

              <button
                onClick={() => {
                  setIsPageChanging(true);
                  setCurrentPage((prev) => Math.min(totalPages, prev + 1));
                }}
                disabled={currentPage === totalPages}
                className="p-1 md:p-2 rounded-md  text-white hover:bg-gray-700/40 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
              >
                <FaChevronRight />
              </button>
            </div>
          )}
        </div>
      </div>
    </BackgroundColor>
  );
}
